const { isANumber } = window.BAO.Utils
export class ProductQuantityLimitMobile extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['translations', 'content']
  }

  static get observedAttributes () {
    return ['available', 'inventory-policy', 'inventory-quantity', 'quantity']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    switch (name) {
      case 'available': {
        this.renderMessage(this.currentInventoryQuantity, this.currentQuantity)
        break
      }
      case 'inventory-policy': {
        this.renderMessage(this.currentInventoryQuantity, this.currentQuantity)
        break
      }
      case 'inventory-quantity': {
        if (!isANumber(newValue)) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleInventoryQuantityUpdateSideEffects(parseInt(newValue, 10))

        break
      }
      case 'quantity': {
        if (!isANumber(newValue)) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleQuantityUpdateSideEffects(parseInt(newValue, 10))

        break
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      !this.hasAttribute('inventory-quantity') ||
      !this.hasAttribute('quantity') ||
      !this.parentEl
    ) {
      return
    }

    this.onQuantityUpdate = this.onQuantityUpdate.bind(this)
    this.onVariantChange = this.onVariantChange.bind(this)

    this.listeners.add(
      this.parentEl,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.onQuantityUpdate,
    )

    this.listeners.add(
      this.parentEl,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChange,
    )
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onQuantityUpdate (event) {
    if (!isANumber(event?.detail?.value)) return
    this.currentQuantity = event.detail.value
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onVariantChange (event) {
    if (!event?.detail?.inventory?.id) return
    this.currentInventoryQuantity = event.detail.inventory.inventory_quantity
    this.currentInventoryPolicy = event.detail.inventory.inventory_policy
    this.isAvailable =
      String(event.detail.inventory.available).toLowerCase() === 'true'
  }

  /**
   * @param {Number} inventoryQuantity
   *
   * @returns {void}
   */
  handleInventoryQuantityUpdateSideEffects (inventoryQuantity) {
    this.renderMessage(inventoryQuantity, this.currentQuantity)
  }

  /**
   * @param {Number} quantity
   *
   * @returns {void}
   */
  handleQuantityUpdateSideEffects (quantity) {
    /* Only visible after quantity update */
    this.setAttribute('aria-hidden', 'false')
    this.renderMessage(this.currentInventoryQuantity, quantity)
  }

  /**
   * @param {Number} inventoryQuantity
   * @param {Number} quantity
   *
   * @returns {void}
   */
  renderMessage (
    inventoryQuantity = this.currentInventoryQuantity,
    quantity = this.currentQuantity,
  ) {
    if (!this.els?.content?.exists) return

    /* No stock count (null, 0 or oversold) has nothing to report, so keep the message hidden */
    const hasStockCount = inventoryQuantity > 0

    if (hasStockCount) {
      this.els.content.element.innerHTML = this.data.quantityLimitMessage
        .replace('[quantity]', inventoryQuantity)
        .replace('<a', '<a is="site-modal-toggle" site-modal-id="pre-order"')
    }

    this.setAttribute(
      'aria-hidden',
      String(
        this.isHiddenByDefault || !hasStockCount || inventoryQuantity > quantity,
      ),
    )
  }

  /**
   * @returns {Boolean}
   */
  get isAvailable () {
    return this.getAttribute('available') === 'true'
  }

  /**
   * @returns {String} continue|deny
   */
  get currentInventoryPolicy () {
    return this.getAttribute('inventory-policy')
  }

  /**
   * @returns {Number}
   */
  get currentQuantity () {
    return parseInt(this.getAttribute('quantity'), 10) || null
  }

  /**
   * @returns {Number}
   */
  get currentInventoryQuantity () {
    return parseInt(this.getAttribute('inventory-quantity'), 10) || null
  }

  /**
   * @param {Number} quantity
   *
   * @returns {void}
   */
  set currentQuantity (quantity) {
    this.setAttribute('quantity', String(quantity))
  }

  /**
   * @param {Number} inventoryQuantity
   *
   * @returns {void}
   */
  set currentInventoryQuantity (inventoryQuantity) {
    this.setAttribute('inventory-quantity', String(inventoryQuantity))
  }

  /**
   * @param {Boolean} available
   *
   * @returns {void}
   */
  set isAvailable (isAvailable) {
    this.setAttribute('available', String(isAvailable))
  }

  /**
   * @param {String} continue|deny
   *
   * @returns {void}
   */
  set currentInventoryPolicy (inventoryPolicy) {
    return this.setAttribute('inventory-policy', inventoryPolicy)
  }

  /**
   * @returns {Object} Translations
   */
  get data () {
    return this.els?.translations?.exists
      ? JSON.parse(this.els.translations.element.innerText)
      : {}
  }

  /**
   * @returns {Boolean}
   */
  get isHiddenByDefault () {
    return !this.isAvailable || this.currentInventoryPolicy === 'continue'
  }

  /**
   * @returns {HTMLElement|null}
   */
  get parentEl () {
    return this.parentSelector
      ? this.closest(this.parentSelector)
      : this.closest('div')
  }

  /**
   * @returns {String|undefined}
   */
  get parentSelector () {
    return this.dataset?.parentSelector
  }
}

if (!customElements.get('product-quantity-limit-mobile')) {
  customElements.define(
    'product-quantity-limit-mobile',
    ProductQuantityLimitMobile,
  )
}
